import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-white border-t border-[#0a0a0a] py-10">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
        <div className="flex items-center gap-4">
          <span className="font-mono font-bold tracking-tighter text-base text-[#0a0a0a]">KURYARTI</span>
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#8a8a8a]">
            © {new Date().getFullYear()} Kuryarti · {t.footer.rights}
          </span>
        </div>
        <div className="flex items-center gap-6">
          <Link to="/privacy" className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#0a0a0a] link-mono">
            {t.footer.privacy}
          </Link>
          <Link to="/terms" className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#0a0a0a] link-mono">
            {t.footer.terms}
          </Link>
          <LanguageSwitcher />
        </div>
      </div>
    </footer>
  );
}
